import { useEffect, useState } from "react";
import HomeHeader from "layouts/homeHeader";
import HomeNavbar from "layouts/homeNavbar";
import BackgroundImage from "assets/images/headerMainPage.jpg";
import DashboardInfoBox from "components/Dashboard/InfoBox";
import DashboardAnnouncements from "components/Dashboard/Announcements";
import DashboardMap from "components/Dashboard/Map";
import styles from "./style.module.scss";
import SettingsIcon from "assets/icons/setting.svg";
import SettingsBlackIcon from "assets/icons/setting-black.svg";
import ChatIcon from "assets/icons/chat.svg";
import ChatBlackIcon from "assets/icons/chat-black.svg";
import AnnouncementIcon from "assets/icons/announcement.svg";
import AnnouncementBlackIcon from "assets/icons/announcement-black.svg";
import HamburgerIcon from "assets/icons/hamburger-black.svg";

const Home = () => {
  const [windowWidth, setWindowWidth] = useState(0);
  useEffect(() => {
    window.addEventListener("resize", () => setWindowWidth(window.innerWidth));
  });

  useEffect(() => {
    setWindowWidth(window.innerWidth);
  }, [window.innerWidth]);

  return (
    <div className={styles.home}>
      <div className={styles.left}>
        <HomeNavbar />
      </div>
      <div className={styles.right}>
      <HomeHeader
          personal="#fff"
          hamburgerIcon={HamburgerIcon}
          announcementIcon={
            windowWidth > 768 ? AnnouncementIcon : AnnouncementBlackIcon
          }
          chatIcon={windowWidth < 768 ? ChatBlackIcon : ChatIcon}
          settingsIcon={windowWidth < 768 ? SettingsBlackIcon : SettingsIcon}
          title="Anasayfa"
          background={BackgroundImage}
          color={"#000"}
        />
        <div className={styles.content}>
          <div className={styles.infobox}>
            <DashboardInfoBox />
          </div>
          <div className={styles.contentMap}>
            <div className={styles.announcement}>
              <DashboardAnnouncements />
            </div>
            <div className={styles.map}>
              <DashboardMap />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
